
type TitleGrayBgProps = {
    text : JSX.Element | string;
    icon? : {
        src : string;
        alt? : string;
    };
    redColor? : boolean;
    textSize? : "larg" | "meduim" | "small"
}

const TitleGrayBg = ({ text, icon, redColor, textSize = "larg" } : TitleGrayBgProps) => {
  return (
    <div className="title-bg-gray">
        <h2 className={`text ${textSize} ${redColor ? "red-text" : ""}`}>{text}</h2>
        {
        icon ?
        <img 
            src={icon.src}
            alt={icon.alt}
            className="icon"
        /> :
        ""
        }
    </div>
  )
}

export default TitleGrayBg